// Sort variants:
export const SORT_DEFAULT = 'default'; // separate row
export const SORT_INLINE = 'inline'; // inline with the header
export const SORT_NONE = 'none'; // no sorting - ignore sortable column props
export const sortVariants = [SORT_NONE, SORT_INLINE, SORT_DEFAULT];
// Expander position variants:
export const EXPANDER_RIGHT = 'right'; // most right position
export const EXPANDER_LEFT = 'left'; // most left position
export const EXPANDER_NONE = 'none'; // no expander
export const expanderVariants = [EXPANDER_RIGHT, EXPANDER_LEFT, EXPANDER_NONE];
//# sourceMappingURL=types.js.map